import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import cx from 'classnames';
import { Theme } from '@seedlang/constants';

const Wrapper = styled.div`
  width: 100%;
  .expand-icon {
    margin: 0 5px 0 auto;
    align-self: flex-start;
    height: 22px;
    color: #868686;
    font-size: 20px;
    pointer-events: none;
  }
`;

const Row = styled.div`
  flex: 1;
  cursor: ${props => props.keepExpanded && !props.actionable ? 'default' : 'pointer'};
  background: ${props => props.plainHeader ? 'transparent' : Theme.lightGray};
  display: flex;
  padding: 10px;
  margin: ${props => props.rowMargin || '10px 0'};
  border-radius: ${props => props.plainHeader ? '0' : '5px'};
  border-bottom: ${props => props.plainHeader ? '1px solid #CCC' : 'none'};
  border-top: ${props => props.showTopSeparator ? '1px solid #CCC' : 'none'};
  transition: background 0.15s ease;
  ${props => !props.disableHover && `
    &:hover {
      background: ${props.keepExpanded && !props.actionable ? Theme.lightGray : '#e2e2e2'};
    }
    &:active {
      background: ${props.keepExpanded && !props.actionable ? Theme.lightGray : '#e5e5e5'};
    }
  `}
`;

const TitleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const ExpandedContentWrapper = styled.div`
  margin: 5px;
  line-height: 20px;
  text-align: left;
`;

@observer
class WordCardRow extends React.Component {

  @computed get expanded() {
    return this.props.keepExpanded || (this.props.expandedId === this.props.id);
  }
  onClick = (e) => {
    if (this.props.actionable && e.target.closest?.('a, button')) return;
    if (e.target.id !== this.props.skipExpandId) {
      this.props.onClick(this.props.id);
    }
  }

  render() {
    return (
      <Wrapper>
        <Row
          onClick={this.onClick}
          plainHeader={this.props.plainHeader}
          showTopSeparator={this.props.showTopSeparator}
          actionable={this.props.actionable}
          disableHover={this.props.disableHover}
          role={this.props.actionable ? 'button' : undefined}
          tabIndex={this.props.actionable ? 0 : undefined}
          onKeyDown={this.props.actionable ? event => {
            if (event.target === event.currentTarget && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              this.onClick(event);
            }
          } : undefined}
          keepExpanded={this.props.keepExpanded}
          rowMargin={this.props.rowMargin}
        >
          <TitleWrapper>
            {this.props.children[0]}
          </TitleWrapper>
          {
            !this.props.keepExpanded &&
              <i
                className={cx('fa', 'expand-icon', {
                  'fa-angle-down': !this.expanded,
                  'fa-angle-up': this.expanded,
                })}
              />
          }
        </Row>
        {
          this.expanded && this.props.children[1] &&
            <ExpandedContentWrapper>
              { this.props.children[1] }
            </ExpandedContentWrapper>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(WordCardRow);
